import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { RequestFormPhone } from '~/src/components/RequestFormPhone';

const breakPoints = {
    tablet: '999px',
};

export const Statistics = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    overflow: hidden;

    &:before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: ${COLORS.white};
        z-index: -2;
    }
`;

export const SRequestFormPhone = styled(RequestFormPhone)`
    label {
        color: ${COLORS.GRAY_LIGHT};

        @media (max-width: ${wideBreakpoints.mobile}) {
            font-size: 10px;
        }

        a {
            color: ${COLORS.GRAY_LIGHT};
            border-bottom: 1px solid ${COLORS.GRAY_LIGHT};
        }
    }

    > div > div {
        > button {
           @media (max-width: ${breakPoints.tablet}) {
               width: 100%;
           }
        }
    }
`;

export const SGridContainer = styled(WideContainer)`
    flex-direction: column;
    flex-wrap: nowrap;
    max-width: 100%;
`;

export const StatElementsWrap = styled.div`
    position: relative;
    height: 750px;
    width: 100%;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        height: 777px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: 856px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 1180px;
    }
`;

export const InnerStatElementsWrap = styled.div`
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-direction: column;
    }
`;

export const StatElem = styled.div`
    flex: 1 0 50%;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    min-height: 150px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        justify-content: center;
    }
`;

export const ElemTitle = styled.div`
    ${FONTS.H0};
    text-align: center;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H1};
    }
`;

export const ElemText = styled.div`
    ${FONTS.XL};
    text-align: center;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.L};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 -8px;
        ${FONTS.S};
    }
`;

export const FormWrap = styled.div`
    position: relative;
    flex: 0 0 auto;
    flex-wrap: nowrap;
    width: 100%;
    padding: 0 60px;
    background-color: ${COLORS.GRAY_DARK};
    border-radius: ${BorderRadius.OuterBlockRadius};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 0 32px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 250px;
    }
`;

export const Description = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    padding: 50px 0 40px 0;

    @media (max-width: ${wideBreakpoints.laptop}) {
        padding: 40px 0 40px 0;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 15px 0 20px 0;
        max-width: 345px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 31px 0 35px 0;
    }
`;

export const FormTitle = styled.div`
    ${FONTS.H2};
    color: ${COLORS.GRAY_LIGHT};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }
`;

export const FormText = styled.div`
    margin-bottom: 20px;
    ${FONTS.M};
    color: ${COLORS.GRAY_LIGHT};

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 18px;
        ${FONTS.XS};
    }
`;

export const ImgWrap = styled.div`
    position: relative;
    flex: 1 0 auto;
    justify-content: center;

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: absolute;
        left: 50%;
        top: 10%;
        z-index: -1;
    }
`;

export const SPicture = styled.picture`
    position: absolute;
    bottom: 0;
    width: 319px;
    height: 347px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 278px;
        height: auto;
    }
`;

export const Img = styled.img`
    position: absolute;
    bottom: 0;
    width: 319px;
    height: 347px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 278px;
        height: auto;
    }
`;

/* Анимированные картинки */
export const AnimImage = styled.div<{ isVisible: boolean }>`
    position: absolute;
    z-index: -1;
    background-repeat: no-repeat;
    background-size: contain;

    transition: all 0.7s ease-out;
`;

export const AnimImageLeft = styled(AnimImage)`
    top: 30px;
    left: ${p => p.isVisible ? '0' : '-50%'};
    width: 670px;
    height: 637px;
    background-position: left top;
    background-image: url('${require('~/static/images/domofon/statistics/left-picture.png')}');

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 560px;
        height: 635px;
        background-position: right top;
        background-size: cover;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        top: 70px;
        width: 440px;
        height: 482px;
    }
`;

export const AnimImageRight = styled(AnimImage)`
    top: 50px;
    right: ${p => p.isVisible ? '0' : '-50%'};
    width: 712px;
    height: 672px;
    background-position: right top;
    background-image: url('${require('~/static/images/domofon/statistics/right-picture.png')}');

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 620px;
        height: 672px;
        background-size: cover;
        background-position: left top;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        top: 70px;
        width: 430px;
        height: 485px;
    }
`;

export const TabletLeftTop = styled(AnimImage)`
    left: ${p => p.isVisible ? '0' : '-50%'};
    width: 206px;
    height: 427px;

    background-position: left top;
    background-image: url(require('~/static/images/domofon/statistics/tablet/left-top.png'));
`;

export const TabletRightTop = styled(AnimImage)`
    right: ${p => p.isVisible ? '0' : '-50%'};
    width: 444px;
    height: 150px;

    background-position: right top;
    background-image: url(require('~/static/images/domofon/statistics/tablet/right-top.png'));
`;

export const TabletLeftBottom = styled(AnimImage)`
    left: ${p => p.isVisible ? '0' : '-50%'};
    bottom: 0;
    width: 289px;
    height: 308px;

    background-position: left bottom;
    background-image: url(require('~/static/images/domofon/statistics/tablet/left-bottom.png'));
`;

export const TabletRightBottom = styled(AnimImage)`
    right: ${p => p.isVisible ? '0' : '-50%'};
    bottom: 0;
    width: 137px;
    height: 315px;

    background-position: right bottom;
    background-image: url(require('~/static/images/domofon/statistics/tablet/right-bottom.png'));
`;

/* Картинки мобильной версии */
export const MobileLeftTop = styled(AnimImage)`
    transition: all 0.5s ease-out;
    top: 120px;
    left: ${p => p.isVisible ? '0' : '-60%'};
    width: 253px;
    height: 516px;

    background-position: left top;
    background-image: url(require('~/static/images/domofon/statistics/mobile/left-top.png'));
`;

export const MobileRightTop = styled(AnimImage)`
    transition: all 0.5s ease-out;
    top: 66px;
    right: ${p => p.isVisible ? '0' : '-60%'};
    width: 253px;
    height: 468px;

    background-position: right top;
    background-image: url(require('~/static/images/domofon/statistics/mobile/right-top.png'));
`;

export const MobileLeftBottom = styled(AnimImage)`
    transition: all 1.2s ease-out;
    left: ${p => p.isVisible ? '0' : '-60%'};
    bottom: 120px;
    width: 132px;
    height: 417px;

    background-position: left bottom;
    background-image: url(require('~/static/images/domofon/statistics/mobile/left-bottom.png'));
`;

export const MobileRightBottom = styled(AnimImage)`
    transition: all 1.2s ease-out;
    right: ${p => p.isVisible ? '0' : '-60%'};
    bottom: 50px;
    width: 172px;
    height: 445px;

    background-position: right bottom;
    background-image: url(require('~/static/images/domofon/statistics/mobile/right-bottom.png'));
`;
